import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { checkoutApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${checkoutApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
